module.exports = __webpack_public_path__ + "img/dw.13d9e345.png";